export default __webpack_public_path__ + "static/media/gable.fea367c9.png";